import Icon, {IconKind} from "@/lib/components/Icon";
import {FlexStyle, StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";
import Badge from "@/lib/components/Badge";

type Props = {
    title: string,
    icon?: IconKind,
    marginTop?: number,
    marginBottom?: number,
    activityBadge?: number,
    center?: boolean,
    size?: number,
}

export default function Header({icon, title, center, activityBadge, marginTop, marginBottom, size}: Props) {
    const height = size ? size : 16;

    const containerStyle = {
        marginTop: marginTop || 0,
        marginBottom: marginBottom || 0,
        minHeight: height + 4,
    }

    const centerStyle: FlexStyle = center ? {justifyContent: "center"} : {};

    const textStyle = {
        fontSize: height,
        lineHeight: height * 1.2,
    }

    return (
        <View style={[styles.container, containerStyle, centerStyle]}>
            {icon && <Icon kind={icon} size={size}/>}
            <Text style={[styles.text, textStyle]}>{title}</Text>
            {activityBadge &&<Badge round={true} title={activityBadge.toString()} color={Color.Red} contrastColor={Color.PrimaryText}/>}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        gap: 8,
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight: 24,
        //marginBottom: 8,
        width: "100%",
    },
    text: {
        color: Color.PrimaryText,
        fontWeight: 600,
    },
    badge: {

    }
})